import {
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
} from "@mui/material";
import { InputWrapper, LabelStyle } from "../../Common/styles/form";
import TipTapFormik from "../../Tiptap/TipTapFormik";
import { SurveyEmailContentVariableChips } from "../surveyEmailContentVariables";

const InvitationTranslation = ({
  touched,
  errors,
  getFieldProps,
  setFieldValue,
  preview,
}: any) => {
  return (
    <>
      {!preview && <SurveyEmailContentVariableChips />}
      <FormControl sx={InputWrapper}>
        <FormLabel sx={LabelStyle} htmlFor="email-subject">
          Email Subject <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TextField
          placeholder="Email Subject"
          id="email-subject"
          {...getFieldProps("invitationSubject")}
          error={
            touched?.invitationSubject && errors?.invitationSubject
              ? true
              : false
          }
          helperText={
            touched?.invitationSubject && errors?.invitationSubject
              ? (errors?.invitationSubject as string)
              : " "
          }
          inputProps={{ readOnly: preview }}
        />
      </FormControl>

      <FormControl sx={InputWrapper}>
        <FormLabel sx={LabelStyle} htmlFor="message-body">
          Message Body <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TipTapFormik
          name="invitationBody"
          setFieldValue={setFieldValue}
          preview={preview}
        />
        {touched?.invitationBody && errors?.invitationBody && (
          <FormHelperText error>
            {errors?.invitationBody as string}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default InvitationTranslation;
